import styled from 'styled-components'

export const DropZoneContainer = styled.div<{ $isExpanded?: boolean }>`
	height: ${({ $isExpanded }) => ($isExpanded ? '60px' : '0px')};
	margin: ${({ $isExpanded }) => ($isExpanded ? '6px 0' : '0px')};
	border-radius: 6px;
	transition: all 0.2s ease;
	background-color: ${({ $isExpanded }) => ($isExpanded ? '#e3f2fd' : 'transparent')};
	border: ${({ $isExpanded }) => ($isExpanded ? '2px dashed #2196f3' : 'none')};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	color: ${({ $isExpanded }) => ($isExpanded ? '#2196f3' : '#6c757d')};
	font-weight: 500;
	position: relative;
	min-width: 100%;
	overflow: hidden;
`
